import DataService from "./DataService";

const POLLING_TIMEOUT = 1000;

class PollingServices {
  constructor() {
    this.pollSetTimeout = null;
    this.isPolling = false;
  }

  startPolling({ url, callback = () => {}, initial = true, timeout = POLLING_TIMEOUT , requestObj = {}}) {
    if (this.isPolling) {
      return;
    }
    this.isPolling = true;
    this.poll(url, callback, initial, timeout, requestObj);
  }

  stopPolling() {
    this.isPolling = false;
    window.clearTimeout(this.pollSetTimeout);
  }

  poll(url, callback, initial, timeout, requestObj = {}) {
    DataService.get(url, requestObj, { kioskadapter: true })
      .then((resp) => {
        callback(resp);
        if (this.isPolling) { // Check if polling is still active before scheduling the next poll
          this.pollSetTimeout = window.setTimeout(() => {
            this.poll(url, callback, false, timeout, requestObj);
          }, timeout);
        }
      })
      .catch((error) => {
        callback(error.response);
        if (this.isPolling) { // Check if polling is still active before scheduling the next poll
          this.pollSetTimeout = window.setTimeout(() => {
            this.poll(url, callback, false, timeout, requestObj);
          }, timeout);
        }
      });
  }
}

export default PollingServices;
